import { render, staticRenderFns } from "./Caracteristicas.vue?vue&type=template&id=33b13ff5"
var script = {}
import style0 from "./Caracteristicas.vue?vue&type=style&index=0&id=33b13ff5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports